<template>
  <v-select
    ref="controlFocoSelectRubro"
    label="Rubro*"
    v-model="iModel"
    :items="items"
    item-value="Id_Rubro"
    item-text="Nombre"
    :rules="rules"
    :readonly="readonly"
    :loading="loading"
  >
    <template v-slot:no-data
      >No hay datos para mostrar</template
    >
    <template v-slot:progress>
      <v-progress-circular color="blue" indeterminate></v-progress-circular>
    </template>
  </v-select>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
export default {
  name: "SelectRubro",
  props: {
    model: Number,
    rules: {},
    readonly: Boolean
  },
  data() {
    return {
      items: [],
      loading: false
    };
  },
  computed: {
    iModel: {
      get() {
        return this.model;
      },
      set(valor) {
        if (valor != undefined && valor != 0) {
          var ind = this.items.findIndex(x => x.Id_Rubro == valor);
          this.$emit("seleccionarItem", this.items[ind]);
          setTimeout(() => {
            eventBus.$emit(
              "listarItemsSelectSubrubro",
              this.items[ind].Id_Rubro
            );
          }, 100);
        }
      }
    }
  },
  created() {
    eventBus.$on("setearFocoSelectRubro", this.setearFoco);
    this.listarItems();
  },
  beforeDestroy() {
    eventBus.$off("setearFocoSelectRubro", this.setearFoco);
  },
  methods: {
    listarItems() {
      this.loading = true;
      HttpHelper.get("Rubro", {
        palabra: ""
      })
        .then(response => {
          this.items = response.data;
          this.loading = false;
        })
        .catch(error => {
          return Promise.reject(error);
        });
    },
    setearFoco() {
      this.$refs.controlFocoSelectRubro.focus();
    }
  }
};
</script>
